import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { asyncAction } from "@client/lib/actions";
import { parseQueryString } from "@client/lib/api";
import { type EntityRef, Status } from "@client/types";
import { type AppState } from "@client/types/AppState";
import { type AnyAction, type Dispatch } from "redux";
import { initAction } from "../actions";
import api from "./api";
import { isDummyOrder } from "./lib";
import { localStateSelector } from "./selectors";
import { type OrderConfirmation } from "./types";

export enum Actions {
  InitBegin = "MODULE_ORDER_CONFIRMATION_INIT_BEGIN",
  InitFailure = "MODULE_ORDER_CONFIRMATION_INIT_FAILURE",
  InitSuccess = "MODULE_ORDER_CONFIRMATION_INIT_SUCCESS",

  DownloadInvoiceBegin = "MODULE_ORDER_CONFIRMATION_DOWNLOAD_INVOICE_BEGIN",
  DownloadInvoiceFailure = "MODULE_ORDER_CONFIRMATION_DOWNLOAD_INVOICE_FAILURE",
  DownloadInvoiceSuccess = "MODULE_ORDER_CONFIRMATION_DOWNLOAD_INVOICE_SUCCESS"
}

export type InitBeginActionData = EntityRef & {
  orderId: string | null;
};
export type InitSuccessActionData = OrderConfirmation.Api.InitResponse;
export const _init = initAction<AppState, InitBeginActionData, OrderConfirmation.Api.InitResponse>({
  types: {
    begin: Actions.InitBegin,
    failure: Actions.InitFailure,
    success: Actions.InitSuccess
  },
  action: (state: AppState, dispatch: Dispatch<AnyAction>, args: InitBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.init(apiInfo, { portalId: state.portal.id, orderId: args.orderId! });
  },
  getShouldInit: (state: AppState, args: InitBeginActionData) => !!args.orderId
});

export type InitArgs = EntityRef & {};
export const init = (args: InitArgs) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);

  if (localState.status === Status.None) {
    const qs = parseQueryString();
    dispatch(
      _init({
        ...args,
        orderId: qs.orderId ?? qs.o ?? null
      })
    );
  }
};

export type DownloadInvoiceBeginActionData = EntityRef & {};
export const _downloadInvoice = asyncAction<AppState, DownloadInvoiceBeginActionData, void>({
  types: {
    begin: Actions.DownloadInvoiceBegin,
    failure: Actions.DownloadInvoiceFailure,
    success: Actions.DownloadInvoiceSuccess
  },
  action: (state: AppState, dispatch: Dispatch<AnyAction>, args: DownloadInvoiceBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);

    return api.downloadInvoice(apiInfo, { portalId: state.portal.id, orderId: parseQueryString().orderId ?? null });
  }
});

export type DownloadInvoiceArgs = EntityRef;
export const downloadInvoice = (args: DownloadInvoiceArgs) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);
  if (isDummyOrder(localState.orderSummary!.order.orderId)) return;

  if (localState.status !== "Downloading") {
    dispatch(_downloadInvoice(args));
  }
};
